import { tap } from 'lodash/fp';
import * as types from './actionTypes';
import * as designBuilderApi from '../api/designBuilder';
import Item from '../models/Item';
import estimateLoaded from './estimateLoaded';
import { itemTypes, itemSources } from '../helpers/globalVariables';
import loading from './loading';
import loaded from './loaded';
import globalError from './globalError';
import uniqueNewName from '../helpers/uniqueNewName';
import smoothScroll from '../helpers/smoothScroll';
import getElementHeight from '../helpers/getElementHeight';

function createItemPayload(designId, containerId, itemName) {
  const item = new Item(itemName);
  item.designId = designId;
  item.containerId = containerId;

  return {
    containerId,
    item,
  };
}

export default containerId => (dispatch, getState) => {
  dispatch(loading());
  const { uiState } = getState().estimateBuilder;
  const { entities } = getState().estimateBuilder;
  const { containers, items } = entities;
  const { byId } = containers;

  const existingNames = byId[containerId].items.map(i => items.byId[i].label);

  const payload = createItemPayload(
    uiState.selectedEstimate,
    containerId,
    uniqueNewName('Window {{num}}', existingNames),
  );

  const apiRequest = {
    design: {
      designId: payload.item.designId,
    },
    items: [
      {
        itemId: payload.item.itemId,
        label: payload.item.label,
        designId: payload.item.designId,
        containerId: payload.item.containerId,
        itemType: itemTypes.window,
        itemSource: itemSources.autobahn,
      },
    ],
  };

  designBuilderApi
    .saveItem(apiRequest)
    .then((response) => {
      dispatch({ type: types.ADD_ITEM, payload });
      dispatch(estimateLoaded(response.data));
      smoothScroll(`#scrollbottom-${containerId}`, getElementHeight('.itemCard'));
    })
    .then(tap(() => dispatch(loaded())))
    .catch(err => dispatch(globalError({ err })));
};
